<template>
  <v-row class="my-0">
    <v-col class="my-0 py-0">
      <v-row
        class="my-0"
        :v-ripple="canViewReferrals"
        align="center"
        :class="canViewReferrals ? 'cursor-pointer' : ''"
        @click="handleViewReferralsClick"
      >
        <v-col cols="auto">
          <v-img
            :src="require('@/assets/images/ui/referrals-icon.svg')"
            max-width="29"
          />
        </v-col>
        <v-col>
          <div :class="['title', canViewReferrals ? 'link' : '']">
            {{ title }}
          </div>
        </v-col>
        <v-col
          cols="auto"
          class="secondary--text title"
        >
          {{ referralsNumber }}
        </v-col>
      </v-row>
      <v-divider />
    </v-col>

    <UserReferralsDialog
      :user-id="user.id"
      :show.sync="showReferralsDialog"
    />
  </v-row>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue } from 'vue-property-decorator'

import { IUser } from '@/types/models/user.model'
import UserReferralsDialog from '@/components/profile/UserReferralsDialog.vue'

@Component({
  components: {
    UserReferralsDialog,
  },
  computed: {
    ...mapGetters(['isAdmin', 'profileID'])
  }
})
export default class UserReferrals extends Vue {
  @Prop() user: IUser
  @Prop({ default: 'Referrals to the platform' }) title: string

  showReferralsDialog: boolean = false

  isAdmin: boolean
  profileID: number

  get referralsNumber (): number {
    if (!this.user) return 0
    return this.user?.referralsNumber || 0
  }

  get canViewReferrals (): boolean {
    return !!this.referralsNumber && (this.isAdmin || this.profileID === this.user.id)
  }

  handleViewReferralsClick () {
    if (!this.canViewReferrals) return
    this.showReferralsDialog = true
    this.$emit('viewReferralsClicked')
  }
}
</script>
